import React, { useEffect } from "react";
import {
  ProfileContext,
} from "./ProfileContext";
import { useContext } from "react";
import { updateProfile, updateProfileImage } from "../../../services//profile";
import AuthContext from "../../Context/AuthProvider";
import jwt_decode from 'jwt-decode';
import {  CREATE_PROFILE_FORM_CACHE_KEY, PROFILE_UPLOAD_STATUS_GETUPLOADDATA_FAILED, PROFILE_UPLOAD_STATUS_UPLOAD_FAILED, PROFILE_UPLOAD_STATUS_UPLOADED } from "../../constants/Constants";
import { addUserAcknowledgement } from "../../../services/acknowledgement";
import { ACKNOWLEDGEMENT_TYPE_DECLARATION, ACKNOWLEDGEMENT_TYPE_TNC } from "../../../services/Constants";
import useAuth from "../../hooks/useAuth";

function Validation({ sendDataForValidation, activeStep, nextStep, renderToast }) {
  const { getToken } = React.useContext(AuthContext);
  const {
    firstName,
    setFirstNameError,
    lastName,
    setLastNameError,
    dateOfBirth,
    setDateOfBirthError,
    timeOfBirth,
    gender,
    setGenderError,
    city,
    setCityError,
    state,
    setStateError,
    country,
    setCountryError,
    pin,
    setPinError,

    // Career Details
    qualification,
    setQualificationError,
    occupation,
    setOccupationError,
    employedIn,
    setEmployedInError,
    annualIncome,
    setAnnualIncomeError,
    isNRI,

    // Social Details
    maritalStatus,
    setMaritalStatusError,
    motherTongue,
    setMotherTongueError,
    religion, //not needed
    nakshatra, //needs to be added
    setNakshatraError,
    kuldevta, //needs to be added
    setKuldevtaError,
    gotra, //needs to be added
    setGotraError,
    rashi,
    setRashiError,
    caste,
    setCasteError,
    languagesKnown,
    setLanguagesKnownError,
    complexion,
    setComplexionError,

    //Other details
    bloodGroup,
    setBloodGroupError,
    // height,
    // setHeightError,

    heightFeet,
    // setHeightFeet,
    heightInch,
    // setHeightInch,
    weight,
    setWeightError,
    foodHabits,
    setFoodHabitsError,
    drinkHabits,
    setDrinkHabitsError,
    smokeHabits,
    setSmokeHabitsError,

    //Familydetails
    fatherName,
    setFatherNameError,
    fatherNumber,
    setFatherNumberError,
    fatherNumberCountry,
    motherName,
    setMotherNameError,
    motherNumber,
    setMotherNumberError,
    motherNumberCountry,

    //About details
    bio,
    setBioError,
    contactNumber,
    contactNumberCountry,
    setContactNumberError,
    contactEmail,
    setContactEmailError,
    profileUploadDataKeys,
    profileImageUploadStatuses,

    //acknowledegments
    tncAckCheckedDuringProfile,
    declarationAckCheckedDuringProfile,
    userPreferences,
    setUserPreferencesError,
    math,
    setMathError
  } = useContext(ProfileContext);
  
  const {
    latestTncVersion
  } = useAuth();

  const CreateProfile = async () => {
    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
    let sleepPromise = sleep(500);
    // let diffInYears = (Date.now() - new Date(dateOfBirth)) / 31557600000;
    // let ageRounded = Math.floor(diffInYears);
    let profile = {
      firstName,
      lastName,
      gender,
      dob: dateOfBirth, // should we channge to age input? or save dob in DB
      timeOfBirth,
      city,
      state,
      pin,
      country,
      qualifications: qualification, //tostring?
      occupation,
      employedIn,
      annualIncome,
      isNRI,
      maritalStatus,
      motherTongue,
      religion,
      caste,
      gotra,
      kuldevta,
      nakshatra,
      rashi,
      languagesKnown, //tostring
      bloodGroup,
      height: Math.floor(heightFeet * 30.48 + heightInch * 2.54),
      weight,
      smokingHabits: smokeHabits,
      drinkingHabits: drinkHabits,
      foodHabits,
      fatherName,
      fatherNumber: `+${fatherNumberCountry}-${fatherNumber}`,
      motherName,
      motherNumber: `+${motherNumberCountry}-${motherNumber}`,
      contactNumber: `+${contactNumberCountry}-${contactNumber}`,
      contactEmail,
      bio,
      userPreferences,
      math
    };
    let auth = getToken();
    if (auth) {
      try {
        const escapedBio = profile.bio.replace(/\n/g, "\\n");
        const escapedUserPreferences = profile.userPreferences.replace(/\n/g, "\\n");

        let response = await updateProfile(auth.token, {...profile, bio: escapedBio, userPreferences: escapedUserPreferences});
        if (response.errors) {
          sendDataForValidation(false);
          return;
        }
      } catch (error) {
        console.error("error in creating profile", error);
        sendDataForValidation(false);
        return;
      }
      let decodedJwt = jwt_decode(auth.token);
      var userId = decodedJwt.sub;
      localStorage.removeItem(`${CREATE_PROFILE_FORM_CACHE_KEY}${userId}`);

      // Get list of successfully uploaded image keys
      const uploadedKeys = profileUploadDataKeys.filter((_, index) => 
        profileImageUploadStatuses[index] === PROFILE_UPLOAD_STATUS_UPLOADED
      );

      if (uploadedKeys.length > 0) {
        try {
          await updateProfileImage(auth.token, uploadedKeys);
        } catch(error) {
          const errorMsg = error?.response?.data?.errors?.[0]?.message?.toLowerCase() ?? "";
          if (errorMsg.includes("partial success")) {
            renderToast("Some images were uploaded successfully. Please uploading the remaining images by going to My Profile page.");
          } else {
            renderToast("There was an error in uploading images, please update images after some time!");
          }
          console.error("Error in uploading profile images", error)
          // In case of error, wait for 5 seconds we give user a chance to see the message
          sleepPromise = sleep(5000);
        }
      }

      try {
        if (tncAckCheckedDuringProfile) {
          var tncAckResponse = await addUserAcknowledgement(
            auth.token,
            ACKNOWLEDGEMENT_TYPE_TNC,
            latestTncVersion,
            ""
          );
          var errorMsg = tncAckResponse.data?.errors?.[0]?.message?.toLowerCase() ?? ""
          if(errorMsg) {
            throw new Error("Error in tnc Ack: " + errorMsg)
          }
        }
        
        if (declarationAckCheckedDuringProfile) {
          const todayDate = new Date().toISOString();
          var declarationAckResponse = await addUserAcknowledgement(
            auth.token,
            ACKNOWLEDGEMENT_TYPE_DECLARATION,
            todayDate.slice(0, 10).replace(/-/g, ""),
            ""
          );
          var errorMsgDec = declarationAckResponse.data?.errors?.[0]?.message?.toLowerCase() ?? ""
          if(errorMsgDec) {
            throw new Error("Error in declarartion Ack: " + errorMsgDec)
          }
        }
      } catch(err) {
        console.error('error in adding user aknowledgements ', err)
      }
      
      await sleepPromise;
      sendDataForValidation(true);
    }
  };

  const MandatoryDetailsValidation = () => {
    let invalidFields = [];
    const field = {
      firstName: {val: firstName, error: setFirstNameError, name: "First Name"},
      lastName: {val: lastName, error: setLastNameError, name: "Last Name"},
      dateOfBirth: {val: dateOfBirth, error: setDateOfBirthError, name: "DOB"},
      gender: {val: gender, error: setGenderError, name: "Gender"},
      city: {val: city, error: setCityError, name: "City"},
      state: {val: state, error: setStateError, name: "State"},
      country: {val: country, error: setCountryError, name: "Country"},
      pin: {val: pin, error: setPinError, name: "Pin Code"},
      occupation: {val: occupation, error: setOccupationError, name: "Occupation"},
      employedIn: {val: employedIn, error: setEmployedInError, name: "Employed In"},
      annualIncome: {val: annualIncome, error: setAnnualIncomeError, name: "Annual Income"},
      marital: { val: maritalStatus, error: setMaritalStatusError, name: "Marital Status" },
      foodHabits: { val: foodHabits, error: setFoodHabitsError, name: "Food Habits" },
      weight: { val: weight, error: setWeightError, name: "Weight" },
      contactNumber: { val: contactNumber, error: setContactNumberError, name: "Contact Number" },
      contactEmail: {val: contactEmail, error: setContactEmailError, name: "Contact Email"},
      userPreferences: {val: userPreferences, error: setUserPreferencesError, name: "Partner Preferences"},
    };
    const isFieldValid = (inputfield) => {
      if (field[inputfield].val === "") {
        field[inputfield].error(true);
        invalidFields.push(field[inputfield].name);
        return false;
      } else {
        field[inputfield].error(false);
        return true;
      }
    };

    const isImageValid = () => {
      const hasAttemptedUpload = profileImageUploadStatuses.some(
        status => status === PROFILE_UPLOAD_STATUS_UPLOADED || 
                 status === PROFILE_UPLOAD_STATUS_UPLOAD_FAILED ||
                 status === PROFILE_UPLOAD_STATUS_GETUPLOADDATA_FAILED
      );
      
      if (!hasAttemptedUpload) {
        invalidFields.push("Profile Image");
        return false;
      }
      return true;
    };

    const isQualificationValid = () => {
      if (qualification.length === 0) {
        setQualificationError(true);
        invalidFields.push("Qualifications")
        return false;
      } else {
        setQualificationError(false);
        return true;
      }
    };
    const isPhoneNumberValid = (inputfield) => {
      if (validatePhoneNumber(contactNumber)) {
        return true;
      } else {
        setContactNumberError(true);
        invalidFields.push("Your Number");
        return false;
      }
    };

    const MandatoryDetailsValid = () => {
      const isFirstNameValidResult = isFieldValid("firstName");
      const isLastNameValidResult = isFieldValid("lastName");
      const isDateOfBirthValidResult = isFieldValid("dateOfBirth");
      const isGenderValidResult = isFieldValid("gender");
      const isCityValidResult = isFieldValid("city");
      const isStateValidResult = isFieldValid("state");
      const isCountryValidResult = isFieldValid("country");
      const isPinValidResult = isFieldValid("pin");
      const checkOccupation = isFieldValid("occupation");
      const checkEmployedIn = isFieldValid("employedIn");
      const checkAnnualIncome = isFieldValid("annualIncome");
      const checkQualification = isQualificationValid();
      const checkMaritalStatus = isFieldValid("marital");
      const checkFoodHabits = isFieldValid("foodHabits");
      const checkWeight = isFieldValid("weight");
      const checkProfileImage = isImageValid();
      const checkContactNumber = isPhoneNumberValid("contactNumber");
      const checkContactEmail = isFieldValid("contactEmail");
      const checkUserPreferences = isFieldValid("userPreferences");
      if (
        isFirstNameValidResult &&
        isLastNameValidResult &&
        isDateOfBirthValidResult &&
        isGenderValidResult &&
        isCityValidResult &&
        isStateValidResult &&
        isCountryValidResult &&
        isPinValidResult &&
        checkOccupation &&
        checkEmployedIn &&
        checkAnnualIncome &&
        checkQualification &&
        checkMaritalStatus &&
        checkFoodHabits &&
        checkWeight &&
        checkProfileImage && 
        checkContactEmail &&
        checkContactNumber &&
        checkUserPreferences
      ) {
        return true;
      } else {
        return false;
      }
    };
    if (MandatoryDetailsValid()) {
      sendDataForValidation(true);
    } else {
      sendDataForValidation(false, invalidFields);
    }
  };

  const validatePhoneNumber = (number) => {
    if(number === "") return true;
    const phoneRegex = /^\+?[1-9][0-9]{1,14}([-\s]?[0-9]{2,4}){1,5}$/;
    return phoneRegex.test(number);
  };
  

  const OptionalDetailsValidation = () => {
     let errorFields = [];
    const field = {
      motherToungue: { val: motherTongue, error: setMotherTongueError },
      caste: { val: caste, error: setCasteError },
      languagesKnown: {
        val: languagesKnown,
        error: setLanguagesKnownError,
      },
      nakshatra: { val: nakshatra, error: setNakshatraError },
      kuldevta: { val: kuldevta, error: setKuldevtaError },
      gotra: { val: gotra, error: setGotraError },
      rashi: { val: rashi, error: setRashiError },
      bloodGroup: { val: bloodGroup, error: setBloodGroupError },
      complexion: { val: complexion, error: setComplexionError },
      drinkHabits: { val: drinkHabits, error: setDrinkHabitsError },
      smokeHabits: { val: smokeHabits, error: setSmokeHabitsError },
      fatherName: { val: fatherName, error: setFatherNameError },
      fatherNumber: { val: fatherNumber, error: setFatherNumberError },
      motherName: { val: motherName, error: setMotherNameError },
      motherNumber: { val: motherNumber, error: setMotherNumberError },
      bio: { val: bio, error: setBioError },
      math: { val: math, error: setMathError },
    };
    const isFieldValid = (inputfield) => {
      field[inputfield].error(false);
      return true;
    };
    const isLanguagesKnownValid = () => {
      setLanguagesKnownError(false);
      return true;
    };
    const isFatherNumberValid = () => {
      if (validatePhoneNumber(fatherNumber)) {
        setFatherNumberError(false);
        return true;
      } else {
        setFatherNumberError(true);
        errorFields.push("Father's Number");
        return false;
      }
    };
    const isMotherNumberValid = () => {
      if (validatePhoneNumber(motherNumber)) {
        setMotherNumberError(false);
        return true;
      } else {
        setMotherNumberError(true);
        errorFields.push("Mother's Number");
        return false;
      }
    };
    const OptionalDetailsValid = () => {
      const checkMotherTongue = isFieldValid("motherToungue");
      const checkCaste = isFieldValid("caste");
      const checkNakshatra = isFieldValid("nakshatra");
      const checkKuldevta = isFieldValid("kuldevta");
      const checkGotra = isFieldValid("gotra");
      const checkRashi = isFieldValid("rashi");
      const checkLanguagesKnown = isLanguagesKnownValid();
      const checkBloodGroup = isFieldValid("bloodGroup");
      const checkComplexion = isFieldValid("complexion");
      const checkDrinkHabits = isFieldValid("drinkHabits");
      const checkSmokeHabits = isFieldValid("smokeHabits");
      const checkFatherName = isFieldValid("fatherName");
      const checkFatherNumber = isFatherNumberValid();
      const checkMotherName = isFieldValid("motherName");
      const checkMotherNumber = isMotherNumberValid();
      const checkBio = isFieldValid("bio");
      const checkMath = isFieldValid("math");
      if (
        checkMotherTongue &&
        checkCaste &&
        checkLanguagesKnown &&
        checkNakshatra &&
        checkKuldevta &&
        checkGotra &&
        checkRashi &&
        checkBloodGroup &&
        checkComplexion &&
        checkDrinkHabits &&
        checkSmokeHabits &&
        checkFatherName &&
        checkFatherNumber &&
        checkMotherName &&
        checkMotherNumber &&
        checkBio &&
        checkMath
      ) {
        return true;
      } else {
        return false;
      }
    };
    if (OptionalDetailsValid()) {
      sendDataForValidation(true);
    } else {
      sendDataForValidation(false, errorFields);
    }
  };
  useEffect(() => {
    switch (activeStep) {
      case 0:
        MandatoryDetailsValidation();
        break;
      case 1:
        OptionalDetailsValidation();
        break;
      case 2:
        if (nextStep === 3)  CreateProfile();
        else sendDataForValidation(true);
        break;
      default:
        sendDataForValidation(true);
    }
  });

  return <></>;
}

export default Validation;
